import { render, staticRenderFns } from "./revert-BDC.vue?vue&type=template&id=8ce46faa"
import script from "./revert-BDC.js?vue&type=script&lang=js&external"
export * from "./revert-BDC.js?vue&type=script&lang=js&external"
import style0 from "./revert-BDC.vue?vue&type=style&index=0&id=8ce46faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports